export const argosApiEntryPoint = 'https://www.scitility.com/argos/api/v1';
export const accountApiEntryPoint = 'https://www.scitility.com/account/api/v1';
export const argosWebsiteBaseLink = 'https://www.scitility.com/argos';